import { HelpdeskTaskStatusEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk.task.status.enum';

/** HD task statuses where client personal account cannot edit description, task type, or EAV */
export const HELPDESK_TASK_PERSONAL_ACCOUNT_LOCKED_CORE_FIELD_STATUSES: readonly HelpdeskTaskStatusEnum[] = [
  HelpdeskTaskStatusEnum.IN_PROCESS,
  HelpdeskTaskStatusEnum.COMPLETED,
];

/** Whether core HD task fields are locked for client personal account editing */
export const isHelpdeskTaskPersonalAccountCoreFieldsLocked = (
  statusCode?: HelpdeskTaskStatusEnum,
): boolean =>
  !!statusCode && HELPDESK_TASK_PERSONAL_ACCOUNT_LOCKED_CORE_FIELD_STATUSES.includes(statusCode);
